<template>
	<div class="order">
		<search-order
			v-on:resetSearch="resetSearch"
			v-on:onSubmit="onSubmit"
			:payStateList="payStateList"
			:payTypeList="payTypeList"
			:search="search"
			:dateTime="dateTime"
		>
		</search-order>
		<div class="vue-padding radius">
			<el-table
				v-loading="loading"
				:empty-text="$t('common.noData')"
				:element-loading-text="$t('common.loading')"
				:data="orderList"
				style="width: 100%"
				max-height="638"
				:border="true"
				@sort-change="sortChange"
			>
				<el-table-column
					prop="userName"
					:label="$t('order.userName')"
					:show-overflow-tooltip="true"
					width="230"
					:align="'center'"
					sortable="custom"
				></el-table-column>
				<el-table-column
					prop="equipmentNo"
					:label="$t('order.equipmentNo')"
					width="140"
					:align="'center'"
					sortable="custom"
				></el-table-column>
				<el-table-column
					prop="equipmentName"
					:label="$t('order.equipmentName')"
					width="180"
					:align="'center'"
					sortable="custom"
				></el-table-column>
				<el-table-column
					prop="goodsName"
					:label="$t('order.goodsName')"
					:show-overflow-tooltip="true"
					width="180"
					:align="'center'"
					sortable="custom"
				>
					<template #default="scope">
						<template
							v-if="
								scope.row.ordersGoods === null ||
									scope.row.ordersGoods === null ||
									(scope.row.ordersGoods && scope.row.ordersGoods.length <= 0)
							"
						>
							{{ scope.row.goodsName }}
						</template>
						<template v-else>
							<el-popover placement="right" trigger="hover">
								<div style="line-height: 2;color: #777;">
									{{ $t("order.oredrMx") }}
								</div>
								<table align="center" width="500" cellspacing="0">
									<thead>
										<tr>
											<th>{{ $t("order.goodsName") }}</th>
											<th>{{ $t("userMachineAlarm.hdNo") }}</th>
											<th>{{ $t("order.price") }}</th>
											<th>{{ $t("order.sellingPrice") }}</th>
											<th>{{ $t("editUserMachine.shuilv") }}</th>
											<th>{{ $t("order.buyNum") }}</th>
										</tr>
									</thead>
									<tbody>
										<!-- 第1行 -->
										<tr
											v-for="(item, index) in scope.row.ordersGoods"
											:key="index"
										>
											<td>{{ item.goodsName }}</td>
											<td>{{ item.aisleNo }}</td>
											<td>{{ item.costPrice }}</td>
											<td>{{ item.sellingPrice }}</td>
											<td>{{ item.vatRate }}%</td>
											<td>{{ item.buyNum }}</td>
										</tr>
									</tbody>
								</table>

								<i
									slot="reference"
									class="el-icon-shopping-cart-2"
									style="font-size: 20px;cursor: pointer;"
								></i>
							</el-popover>
						</template>
					</template>
				</el-table-column>
				<el-table-column
					prop="orderNumber"
					:label="$t('order.orderNumber')"
					width="200"
					:align="'center'"
				></el-table-column>
				<el-table-column
					prop="aisleNo"
					:label="$t('userMachineAlarm.hdNo')"
					width="110"
					:align="'center'"
				>
					<template #default="scope">
						<template
							v-if="
								scope.row.ordersGoods === null ||
									(scope.row.ordersGoods && scope.row.ordersGoods.length <= 0)
							"
						>
							{{ scope.row.aisleNo }}
						</template>
						<template v-else>
							<el-popover placement="right" trigger="hover">
								<div style="line-height: 2;color: #777;">
									{{ $t("order.oredrMx") }}
								</div>
								<table align="center" width="500" cellspacing="0">
									<thead>
										<tr>
											<th>{{ $t("order.goodsName") }}</th>
											<th>{{ $t("userMachineAlarm.hdNo") }}</th>
											<th>{{ $t("order.price") }}</th>
											<th>{{ $t("order.sellingPrice") }}</th>
											<th>{{ $t("editUserMachine.shuilv") }}</th>
											<th>{{ $t("order.buyNum") }}</th>
										</tr>
									</thead>
									<tbody>
										<!-- 第1行 -->
										<tr
											v-for="(item, index) in scope.row.ordersGoods"
											:key="index"
										>
											<td>{{ item.goodsName }}</td>
											<td>{{ item.aisleNo }}</td>
											<td>{{ item.costPrice }}</td>
											<td>{{ item.sellingPrice }}</td>
											<td>{{ item.vatRate }}%</td>
											<td>{{ item.buyNum }}</td>
										</tr>
									</tbody>
								</table>

								<i
									slot="reference"
									class="el-icon-shopping-cart-2"
									style="font-size: 20px;cursor: pointer;"
								></i>
							</el-popover>
						</template>
					</template>
				</el-table-column>
				<el-table-column
					prop="costPrice"
					:label="$t('order.price')"
					width="90"
					:align="'center'"
				>
					<template #default="scope">
						<template
							v-if="
								scope.row.ordersGoods === null ||
									(scope.row.ordersGoods && scope.row.ordersGoods.length <= 0)
							"
						>
							{{ scope.row.costPrice }}
						</template>
						<template v-else>
							<el-popover placement="right" trigger="hover">
								<div style="line-height: 2;color: #777;">
									{{ $t("order.oredrMx") }}
								</div>
								<table align="center" width="500" cellspacing="0">
									<thead>
										<tr>
											<th>{{ $t("order.goodsName") }}</th>
											<th>{{ $t("userMachineAlarm.hdNo") }}</th>
											<th>{{ $t("order.price") }}</th>
											<th>{{ $t("order.sellingPrice") }}</th>
											<th>{{ $t("editUserMachine.shuilv") }}</th>
											<th>{{ $t("order.buyNum") }}</th>
										</tr>
									</thead>
									<tbody>
										<!-- 第1行 -->
										<tr
											v-for="(item, index) in scope.row.ordersGoods"
											:key="index"
										>
											<td>{{ item.goodsName }}</td>
											<td>{{ item.aisleNo }}</td>
											<td>{{ item.costPrice }}</td>
											<td>{{ item.sellingPrice }}</td>
											<td>{{ item.vatRate }}%</td>
											<td>{{ item.buyNum }}</td>
										</tr>
									</tbody>
								</table>

								<i
									slot="reference"
									class="el-icon-shopping-cart-2"
									style="font-size: 20px;cursor: pointer;"
								></i>
							</el-popover>
						</template>
					</template>
				</el-table-column>
				<el-table-column
					prop="sellingPrice"
					:label="$t('order.sellingPrice')"
					width="100"
					:align="'center'"
				>
					<template #default="scope">
						<template
							v-if="
								scope.row.ordersGoods === null ||
									(scope.row.ordersGoods && scope.row.ordersGoods.length <= 0)
							"
						>
							{{ scope.row.sellingPrice }}
						</template>
						<template v-else>
							<el-popover placement="right" trigger="hover">
								<div style="line-height: 2;color: #777;">
									{{ $t("order.oredrMx") }}
								</div>
								<table align="center" width="500" cellspacing="0">
									<thead>
										<tr>
											<th>{{ $t("order.goodsName") }}</th>
											<th>{{ $t("userMachineAlarm.hdNo") }}</th>
											<th>{{ $t("order.price") }}</th>
											<th>{{ $t("order.sellingPrice") }}</th>
											<th>{{ $t("editUserMachine.shuilv") }}</th>
											<th>{{ $t("order.buyNum") }}</th>
										</tr>
									</thead>
									<tbody>
										<!-- 第1行 -->
										<tr
											v-for="(item, index) in scope.row.ordersGoods"
											:key="index"
										>
											<td>{{ item.goodsName }}</td>
											<td>{{ item.aisleNo }}</td>
											<td>{{ item.costPrice }}</td>
											<td>{{ item.sellingPrice }}</td>
											<td>{{ item.vatRate }}%</td>
											<td>{{ item.buyNum }}</td>
										</tr>
									</tbody>
								</table>

								<i
									slot="reference"
									class="el-icon-shopping-cart-2"
									style="font-size: 20px;cursor: pointer;"
								></i>
							</el-popover>
						</template>
					</template>
				</el-table-column>
				<!-- 税率 -->
				<el-table-column
					prop="vatRate"
					:label="$t('editUserMachine.shuilv')"
					width="100"
					:align="'center'"
				>
					<template #default="scope">
						<template
							v-if="
								scope.row.ordersGoods === null ||
									(scope.row.ordersGoods && scope.row.ordersGoods.length <= 0)
							"
						>
							{{ scope.row.vatRate }}%
						</template>
						<template v-else>
							<el-popover placement="right" trigger="hover">
								<div style="line-height: 2;color: #777;">
									{{ $t("order.oredrMx") }}
								</div>
								<table align="center" width="500" cellspacing="0">
									<thead>
										<tr>
											<th>{{ $t("order.goodsName") }}</th>
											<th>{{ $t("userMachineAlarm.hdNo") }}</th>
											<th>{{ $t("order.price") }}</th>
											<th>{{ $t("order.sellingPrice") }}</th>
											<th>{{ $t("editUserMachine.shuilv") }}</th>
											<th>{{ $t("order.buyNum") }}</th>
										</tr>
									</thead>
									<tbody>
										<tr
											v-for="(item, index) in scope.row.ordersGoods"
											:key="index"
										>
											<td>{{ item.goodsName }}</td>
											<td>{{ item.aisleNo }}</td>
											<td>{{ item.costPrice }}</td>
											<td>{{ item.sellingPrice }}</td>
											<td>{{ item.vatRate }}%</td>
											<td>{{ item.buyNum }}</td>
										</tr>
									</tbody>
								</table>

								<i
									slot="reference"
									class="el-icon-shopping-cart-2"
									style="font-size: 20px;cursor: pointer;"
								></i>
							</el-popover>
						</template>
					</template>
				</el-table-column>
				<el-table-column
					prop="payPrice"
					:label="$t('order.duePrice')"
					width="120"
					:align="'center'"
				></el-table-column>
				<el-table-column
					prop="discountPrice"
					:label="$t('retainer.discountPrice')"
					width="130"
					:align="'center'"
				></el-table-column>
				<el-table-column
					prop="payablePrice"
					:label="$t('order.actualPrice')"
					width="130"
					:align="'center'"
				></el-table-column>
				<el-table-column
					prop="buyNum"
					:label="$t('order.buyNum')"
					width="130"
					:align="'center'"
				></el-table-column>
				<el-table-column
					prop="payState"
					:label="$t('order.payState')"
					width="130"
					:align="'center'"
					:formatter="payState"
				></el-table-column>
				<el-table-column
					prop="payType"
					:label="$t('order.payType')"
					width="160"
					:align="'center'"
				>
					<template slot-scope="scope">
						<span
							v-if="scope.row.payType === '5'"
							style="color: #409EFF"
							class="card"
						>
							<el-popover placement="top" trigger="hover">
								<span style="font-size: 18px"
									>CardNo: {{ scope.row.icard }}</span
								>
								<span slot="reference">{{ payType(scope.row) }}</span>
							</el-popover>
						</span>
						<span v-else>{{ payType(scope.row) }}</span>
					</template>
				</el-table-column>
				<el-table-column
					prop="refundMsg"
					:label="$t('order.refundInfo')"
					width="200"
					:align="'center'"
					:show-overflow-tooltip="true"
				></el-table-column>
				<el-table-column
					prop="buyTime"
					:label="$t('order.createTime')"
					width="160"
					:align="'center'"
					sortable="custom"
				></el-table-column>
				<el-table-column
					prop="createTime"
					:label="$t('advertGroup.createTime')"
					width="160"
					:align="'center'"
					sortable="custom"
				></el-table-column>
				<el-table-column
					fixed="right"
					:label="$t('common.operate')"
					:width="$i18n.locale == 'zh_CN' ? 200 : 200"
					:align="'center'"
				>
					<template slot-scope="scope">
						<template
							v-if="
								scope.row.payType == 4 &&
									(scope.row.payState == 1 ||
										scope.row.payState == 2 ||
										scope.row.payState == -1)
							"
						>
							<el-button type="danger" size="mini" @click="revoke(scope.row)">{{
								$t("order.tuikuang")
							}}</el-button>
						</template>
					</template>
				</el-table-column>
			</el-table>
			<el-pagination
				background
				layout="total,sizes,prev, pager, next,jumper"
				:current-page="page.pageIndex"
				:total="page.totalSize"
				:page-size="page.pageSize"
				@size-change="sizeChange"
				@current-change="currentChange"
			></el-pagination>
		</div>
	</div>
</template>

<script>
import searchOrder from "_c/order/SearchOrder";
export default {
	name: "Order",
	components: {
		searchOrder,
	},
	data() {
		return {
			search: {
				goodsName: "",
				equipmentNo: "",
				equipmentName: "",
				orderNumber: "",
				trxNo: "",
				payState: "",
				payType: "",
				startTime: "",
				endTime: "",
				userName: "",
			},
			dateTime: [],
			loading: false,
			page: {
				pageSize: 10,
				pageIndex: 1,
			},
			payStateList: [],
			orderList: [],
			payTypeList: [],
			dialogQueryJoinOrder: false,
			dialogQueryJoinRefundOrder: false,
			orderNumber: "",
			zone: this.$cookies.get("zone"),
		};
	},
	mounted() {
		let _self = this;
		_self.listPayState();
		// 提前设置时间
		_self.dateTime = [
			new Date(new Date().getTime() - 7 * 24 * 60 * 60 * 1000),
			new Date(),
		];
		_self.search.startTime = this.$timeUtil.formatTime(_self.dateTime[0]);
		_self.search.endTime = this.$timeUtil.formatTime(_self.dateTime[1]);

		_self.currentChange();
		_self.listPayType();
	},
	methods: {
		sortChange(column) {
			if (column.order === "ascending") {
				this.search.order = "asc";
				this.search.sort = column.prop;
			} else if (column.order === "descending") {
				this.search.order = "desc";
				this.search.sort = column.prop;
			} else {
				delete this.search.sort;
				delete this.search.order;
			}
			this.page.pageIndex = 1;
			this.currentChange();
		},
		revoke(row) {
			this.$confirm(this.$t("order.tipcontent"), this.$t("common.tip"), {
				confirmButtonText: this.$t("common.definite"),
				cancelButtonText: this.$t("common.cancel"),
				type: "warning",
			}).then(() => {
				this.$api
					.request(this.$url.Order.refundByOrderId, this.$method.post, {
						orderId: row.id,
					})
					.then(res => {
						if (res.code === 0) {
							this.$notify({
								title: this.$t("common.tip"),
								message: res.msg,
								type: "success",
							});
							this.currentChange(1);
						}
					});
			});
		},
		listPayState() {
			this.$api.dict("gp_pay_state").then(res => {
				if (res.code === 0) {
					this.payStateList = res.data;
				}
			});
		},
		listPayType() {
			this.$api.dict("gp_pay_type").then(res => {
				if (res.code === 0) {
					this.payTypeList = res.data;
				}
			});
		},
		sizeChange(pageSize) {
			this.page.pageSize = pageSize;
			this.currentChange();
		},
		currentChange(pageIndex) {
			this.loading = true;
			this.page.pageIndex = pageIndex ? pageIndex : 1;
			let obj = this.$cloud.objMerge(this.search, this.page);
			this.$api
				.request(this.$url.Order.page, this.$method.get, obj)
				.then(res => {
					if (res.code === 0) {
						this.orderList = res.data.records;
						this.page.totalSize = parseInt(res.data.total);
					}
					this.loading = false;
				})
				.catch(() => {
					this.loading = false;
				});
		},
		// 格式化订单状态内容
		payState(row) {
			return this.$cloud.getDictLabel(this.payStateList, row.payState);
		},
		// 格式化付款方式内容
		payType(row) {
			return this.$cloud.getDictLabel(this.payTypeList, row.payType);
		},

		onSubmit(data) {
			this.search = data;
			this.dateTime = [new Date(data.startTime), new Date(data.endTime)];
			this.currentChange();
		},
		resetSearch(data) {
			this.search = data;
			// this.getDefault();
			this.currentChange();
		},
	},
};
</script>

<style lang="scss">
.order {
	.card {
		color: #409eff;
		cursor: pointer;
	}
}
</style>
<style scoped lang="scss">
table {
	border-right: 1px solid #000000;
	border-bottom: 1px solid #000000;
	text-align: center;
}

table th {
	border-left: 1px solid #000000;
	border-top: 1px solid #000000;
	font-weight: normal;
}

table td {
	border-left: 1px solid #000000;
	border-top: 1px solid #000000;
}
</style>
